import { createI18n } from 'vue-i18n'
import nl from './locales/nl.json';
import nl_grip from './locales/nl_grip.json';



export default createI18n({
  // locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  locale: window.location.pathname === '/grip/financieelinzicht/eerderstoppenmetwerken/' ? 'grip' : 'nl',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'nl',
  messages: {'nl': nl, 'grip' : nl_grip}
})
